import { PROJECT_VARIANTS } from '../../constants';
import * as activ8Actions from '../../redux/activ8/activ8Actions';
import * as activ8MessagesActions from '../../redux/activ8/activ8MessagesActions';
import * as consumerActiv8Actions from '../../redux/consumer/activ8/consumerActiv8Reducer';

const activ8ActionsMapping = {
  searchContent: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.findActiv8Content,
    [PROJECT_VARIANTS.CONSUMER]: consumerActiv8Actions.findConsumerActiv8Content,
  },
  searchTags: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.findActiv8Tags,
    [PROJECT_VARIANTS.CONSUMER]: consumerActiv8Actions.findConsumerActiv8Tags,
  },
  getContentUsers: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.getActiv8ContentUsers,
  },
  likeContent: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.likeActiv8Content,
    [PROJECT_VARIANTS.CONSUMER]: consumerActiv8Actions.likeConsumerActiv8Content,
  },
  getDuplicates: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.getDuplicates,
  },
  downloadSource: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.downloadSource,
  },
  downloadActiv8MediaDisplay: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.downloadActiv8MediaDisplay,
    // [PROJECT_VARIANTS.CONSUMER]: consumerActiv8Actions.downloadConsumerActiv8MediaDisplay,
  },
  deleteContent: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.deleteActiv8Content,
  },
  updateContentById: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.updateContentById,
  },
  editTags: {
    [PROJECT_VARIANTS.ADMIN]: activ8Actions.editTags,
  },

  generateMessages: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.generateActiv8Messages,
  },
  replyMessages: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.replyActiv8Messages,
  },
  clearSession: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.clearSession,
  },
  deleteMultipleMessages: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.deleteMultipleActiv8Messages,
  },
  deleteSavedMessages: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.deleteSavedActiv8Messages,
  },
  saveMessage: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.saveActiv8Message,
  },
  deleteMessage: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.deleteActiv8Message,
  },
  getMessageLogs: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.getActiv8MessageLogs,
  },
  createMessage: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.createActiv8Message,
  },
  editMessage: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.editActiv8Message,
  },
  searchMessages: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.searchActiv8Messages,
  },

  adjustMessages: {
    [PROJECT_VARIANTS.ADMIN]: activ8MessagesActions.adjustMessages,
  },
};

export default activ8ActionsMapping;
